export type Subscription = {
  subscription: string;
  value: string;
};

export const defaultSubscriptions: Subscription[] = [
  {
    subscription: 'Preschool',
    value: 'polyglutt-preschool',
  },
  {
    subscription: 'Preschool Consumer',
    value: 'polyglutt-preschool-consumer',
  },
  {
    subscription: 'School',
    value: 'polyglutt-school',
  },
  {
    subscription: 'School Primary NA',
    value: 'polylino-school-primary-na',
  },
  {
    subscription: 'School Secondary',
    value: 'polylino-school-secondary',
  },
  {
    subscription: 'School Secondary NA',
    value: 'polylino-school-secondary-na',
  },
  {
    subscription: 'High school',
    value: 'polylino-school-high',
  },
  {
    subscription: 'Yvelines',
    value: 'polylino-school-yvelines',
  },
  {
    subscription: 'Home Access',
    value: 'polyglutt-preschool-home-access',
  },
  {
    subscription: 'School Consumer',
    value: 'polylino-school-consumer',
  },
  {
    subscription: 'School Lite',
    value: 'polylino-school-lite',
  },
  {
    subscription: 'Manabua - mellanstadiet',
    value: 'immigrant-m',
  },
  {
    subscription: 'Manabua - högstadiet',
    value: 'immigrant-h',
  },
  {
    subscription: 'Manabua - VO gymnasiet',
    value: 'immigrant-g-vo',
  },
  {
    subscription: 'Manabua - BF gymnasiet',
    value: 'immigrant-g-bf',
  },
  {
    subscription: 'Manabua - FT gymnasiet',
    value: 'immigrant-g-ft',
  },
  {
    subscription: 'Manabua - RL gymnasiet',
    value: 'immigrant-g-rl',
  },
  {
    subscription: 'Inlasta Läromedel',
    value: 'dyslexia',
  },
  {
    subscription: 'STR',
    value: 'str',
  },
  {
    subscription: 'Aski Raski',
    value: 'askiraski',
  },
  {
    subscription: 'Aski Raski - materials',
    value: 'askiraski-materials',
  },
  {
    subscription: 'Educateit Healthcare',
    value: 'educateit-healthcare',
  },
];
